import React from "react";
import { useCart } from "../../contexts/CartContext";
import CartItem from "./CartItem";

function CartList({ items, onSelectItem, onNavigateItem, selectedItemId, registerItemRef }) {
  const { removeItem } = useCart();

  if (items.length === 0) {
    return (
      <div className="no-results">
        <p>Your cart is empty.</p>
        <a href="/">Start a new search</a>
      </div>
    );
  }

  return (
    <div className="search-results cart-list">
      {items.map((item) => {
        const itemId = item.program_site_id || item.id;
        return (
          <CartItem
            key={itemId}
            ref={registerItemRef ? (node) => registerItemRef(itemId, node) : undefined}
            item={item}
            onSelect={onSelectItem}
            onNavigate={onNavigateItem}
            onRemove={removeItem}
            isSelected={selectedItemId === itemId}
          />
        );
      })}
    </div>
  );
}

export default CartList;
